import {API_BIDATA,API_BIDATAS,API_WX} from '../../config/api';
let apiNew={};
// 接口配置(计费)
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
	if (window.location.protocol == "http:") {
		apiNew.relation = API_BIDATA;
	} else if (window.location.protocol == "https:") {
		apiNew.relation = API_BIDATAS;
	}
	apiNew.wx = API_WX;
}else{
	if (window.location.protocol == "http:") {
		apiNew.relation = window.api.bidata;
	} else if (window.location.protocol == "https:") {
		apiNew.relation = window.api.bidatas;
	}
	apiNew.wx = window.api.wx;
}
var api = {
	// 登录
	login: apiNew.relation + "/portal/login", //账户密码登录
	// login: apiNew.relation + "/portal-api/v1/login", //账户密码登录
	WXRegister: apiNew.wx + "/customers/register", //申请试用
	WXVerifyCode: apiNew.wx + "/users/verifyCode", //手机验证码
	WXLoginOfMobile: apiNew.wx + "/login/mobile", //手机号码登录
	// 模糊查询
	blurredQuery : apiNew.wx + "/list?key=",
	// 下载表格
	save_relation: apiNew.relation+"/portal/kyc/beneficiary/excel/order",
	download_exl: apiNew.relation+"/portal/kyc/beneficiary/excel/download",
	// 图谱
	bennifit_relation: apiNew.wx + "/kyc/beneficiary/query",
	//退出登录
	out_login: apiNew.relation + "/portal/logout",
	// out_login: apiNew.relation + "/portal-api/v1/logout",
	
	// 导出全景图
	export_img : apiNew.relation+"/portal/kyc/beneficiary/img/order",
	export_img_l : apiNew.relation+"/portal/kyc/beneficiary/img/download",

	
	// 通过token获取信息
	// getInfo:apiNew.relation+"/portal-api/v1/token/",
	
	// pre:pre+"/portal-api/v1",
	// base:base
}

export default api



// WEBPACK FOOTER //
// ./src/common/api.js